<template>
  <div>
    <div class="float-left ml-5 mt-2">
      <router-link to="/account"><< Back</router-link>
    </div>
    <br />
    <div class="mt-2 alert alert-success" v-show="success">Save succcessful!</div>
    <div class="mt-3">
      <h5>{{account.username}}</h5>
    </div>
    <button class="btn btn-primary my-3" v-on:click="save">Save</button>

    <!-- Start of Accordion -->
    <div id="accordion">
      <div class="card" v-for="(d, i) in transformedData">
        <!-- Header -->
        <div class="card-header" id="headingOne">
          <h5 class="mb-0">
            <button
              class="btn btn-link"
              data-toggle="collapse"
              v-bind:data-target="'#collapse'+i"
              aria-expanded="true"
              v-bind:aria-controls="'collapse'+i"
            >{{d[0].department}}</button>
          </h5>
        </div>

        <!-- Body -->
        <div
          v-bind:id="'collapse'+i"
          class="collapse"
          aria-labelledby="headingOne"
          data-parent="#accordion"
        >
          <div class="card-body">
            <div v-for="(r, i2) in d">
              <input type="checkbox" v-model="selectedRoles" :id="'mr'+r.id" :value="r.id" />
              <label :for="'mr'+r.id">{{r.name}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End of Accordion -->
    <button class="btn btn-primary my-3" v-on:click="save">Save</button>
  </div>
</template>

<script>
import http from "../commons/http.js";
export default {
  data: function() {
    return {
      transformedData:[],
      roles: [],
      accountId: 0,
      account: {},
      selectedRoles: [],
      success:false
    };
  },
  methods: {
    getMinistryRoles: async function() {
      try {
        let response = await http.get("/ministryrole?sort=department&limit=999");
        this.roles = response.data;
        if(this.roles.length === 0){
            alert("No data found");
        }else{
          this.transformData();
        }
      } catch (err) {
        console.error("fetch roles err", err);
      }
    },
    getAccount: async function() {
      let response = await http.get("/account/withpermission/"+this.accountId);
      this.account = response.data[0];

      let $this = this;
      this.account.permissions.forEach(function(p) {
        $this.selectedRoles.push(p.ministryRole.id);
      });

    },
    transformData:function(){
      let allDept = [];

      let previousDept = "";
      let sameDept = [];
      for(let i=0 ; i<this.roles.length ; i++){
        let role = this.roles[i];
        let currentDept = role.department;
        
        if(i === 0){ // first iteration
          sameDept.push(role);
          previousDept = currentDept;
        }else{
          if(currentDept === previousDept){ // same dept
            sameDept.push(role);

            if(i === this.roles.length - 1){ // last iteration              
              allDept.push(sameDept);
            }

          }else{ // diff dept
            allDept.push(sameDept);
            sameDept = [];
            sameDept.push(role);
            
            if(i === this.roles.length - 1){ // last iteration
              allDept.push(sameDept);
            }
          }
          previousDept = currentDept;
        }
        
      }
      this.transformedData = allDept;
      console.log('transformedData', this.transformedData);
    },
    save: async function(){
        try{
            let response = await http.post('/ministryrolepermission/save', {id:this.accountId, ministryRoles:this.selectedRoles});
            console.log('success', response.data);
            this.success = true;
            let $this = this;
            setTimeout(function(){
              $this.success = false;
            }, 2000);
        }catch(err){
            console.error('save err', err)
        }
    }
  },
  beforeMount: async function() {
      if(!await http.isLoggedIn()){
      this.$router.push('/adminlogin');
    }
    this.getMinistryRoles();
    this.accountId = this.$route.query.id;
    this.getAccount();
    
  }
};
</script>

<style>
</style>
